import { render } from "./IconButton.vue?vue&type=template&id=25a0ef8f&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=25a0ef8f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-25a0ef8f"

export default script